module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("Display <a href=\"/docs/api#possible-event-types\" target=\"_blank\" class=\"fa fa-question-circle text-muted\"></a> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/webhooks_and_events/events/event_description_display_heading.ejs
// module id = 1865
// module chunks = 1